import { useMemo, useRef, useState } from "react";
import { useTranslate } from "@refinedev/core";

import { useQueryParams } from "@shared/hooks";
import { useFetchResourcesByIdsQuery } from "@shared/services/queries";
import { ApiResponse } from "@shared/types";
import { Referral } from "@modules/referrals/types/referral";
import { Company } from "@modules/companies/types";
import { usePaginatedTable } from "@shared/hooks/usePaginatedTable";
import { ModalRef } from "@shared/components";

export function useReferralList() {
  const [selectedRows, setSelectedRows] = useState<string[]>([]);
  const payModalRef = useRef<ModalRef>(null);

  const translate = useTranslate();
  const { getQueryParams } = useQueryParams();

  const { rows, loading, refetch, ...tableProps } = usePaginatedTable<Referral>({
    resource: "admin/referral",
    filters: getQueryParams(),
    sorters: { ordering: "-created_at" },
  });

  const companiesIds = useMemo(
    () => [...new Set(rows?.map((referral) => referral.agreement).filter((id): id is number => !!id))],
    [rows]
  );

  const { data: companies } = useFetchResourcesByIdsQuery<ApiResponse<Company>>({
    resource: "v1/company_admin",
    ids: companiesIds,
  });

  const dataToExport = useMemo(() => {
    return selectedRows.length > 0
      ? rows.filter((row) => selectedRows.includes(String(row.id)))
      : rows;
  }, [selectedRows, rows]);

  return {
    rows,
    loading,
    tableProps,
    selectedRows,
    dataToExport,
    companies: companies?.results,
    payModalRef,

    refetch,
    setSelectedRows,
    translate,
  };
}

